import { render, staticRenderFns } from "./OrganizationEditDetails.vue?vue&type=template&id=6ad29ab6&scoped=true&"
import script from "./OrganizationEditDetails.vue?vue&type=script&lang=js&"
export * from "./OrganizationEditDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad29ab6",
  null
  
)

export default component.exports